export default "__VITE_ASSET__4623c1ec__"